import { LightShowSegment } from './lightshow-segment';
import { LightShowOperation } from '../Operations/lightshow-operation';
import { VibrateOperation } from '../Operations/vibrate-operation';

export class VibrateSegment extends LightShowSegment {

  public init() {
    this.color = 'cyan';
    this.minDuration = 100;
    this.enableSegmentGrips = false;
  }

  public addOperations(operations: LightShowOperation[]) {
    operations.push(new VibrateOperation(this.position, this.segmentId));
  }
}
